<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="main-characters">
<h1>Main Characters</h1>
<p>William Surtees Hetherington</p>
<p>Joseph Hetherington, brother</p>
<p>Dorothy Hetherington, sister</p>
<p>Arthur Hetherington, brother</p>
<p>Annie, Arthur’s wife</p>
<p>Mr Straker, viewer at Felling Mine</p>
<p>Miguel, Spanish sailor</p>
<p>John Boulder, Irish sailor</p>
<p>Captain Croke, Captain of HMS Shannon</p>
<p>John (aka Jack) Wilkinson, miner, then highwayman</p>
<p>Eliza Bainbridge, Surtees’s beloved</p>
<p>Evie, Eliza’s sister</p>
<p>Farmer Duke</p>
<p>Tammy, highwayman</p>
<p>Thomas Dodds, highwayman</p>
<p>Samuel Maddison, highwayman and police informer</p>
<p>Mr Blake, gaoler at Morpeth Gaol</p>
<p>Justice Holroyd, judge at Morpeth Assizes</p>
<p>John Marshall and Michael Butler, activists against capital punishment</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?02674f56